"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _TeamsPlugin = /*#__PURE__*/ _interop_require_default(require("./TeamsPlugin"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const config = {
    builder: _TeamsPlugin.default,
    id: 'ms-teams',
    title: 'Microsoft Teams',
    version: '0.0.1',
    logo: 'plugins/teams.ico',
    description: 'Microsoft Teams is for everyone · Instantly go from group chat to video call with the touch of a button.',
    price: 'Free',
    tags: 'Chat',
    category: 'Chat',
    inputs: {
        title: 'Configure Microsoft Teams',
        array: true,
        items: [
            {
                key: 'channel',
                label: 'Channel Name',
                placeholder: 'Channel Name',
                type: _nocodbsdk.XcType.SingleLineText,
                required: true
            },
            {
                key: 'webhook_url',
                label: 'Webhook URL',
                placeholder: 'Webhook URL',
                type: _nocodbsdk.XcType.Password,
                required: true
            }
        ],
        actions: [
            {
                label: 'Test',
                placeholder: 'Test',
                key: 'test',
                actionType: _nocodbsdk.XcActionType.TEST,
                type: _nocodbsdk.XcType.Button
            },
            {
                label: 'Save',
                placeholder: 'Save',
                key: 'save',
                actionType: _nocodbsdk.XcActionType.SUBMIT,
                type: _nocodbsdk.XcType.Button
            }
        ],
        msgOnInstall: 'Successfully installed and Microsoft Teams is enabled for notification.',
        msgOnUninstall: ''
    }
};
const _default = config;
